import { render, staticRenderFns } from "./new-sms-campaign-preview.vue?vue&type=template&id=118b40fc&scoped=true"
import script from "./new-sms-campaign-preview.vue?vue&type=script&lang=js"
export * from "./new-sms-campaign-preview.vue?vue&type=script&lang=js"
import style0 from "./new-sms-campaign-preview.vue?vue&type=style&index=0&id=118b40fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b40fc",
  null
  
)

export default component.exports